
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";

interface dataBanner {
  id: number;
  imagen: string;
  imagen_mobile: string;
  link: string;
}

interface dataComercio {
  logo: string;
  nombre: string;
  nombre_web: string;
}

@Component
export default class Home extends Vue {
  private aBanners: Array<dataBanner> = [];
  private slide = 0;
  private slideIndex: number = 1;
  private popUp: any = null;
  private verPopUp = false;
  private verPopUpMultiple = false;
  private slidePopUp = 0;

  private aComercios: Array<dataComercio> = [];
  private horizontalPercentageComercios = 0;
  private horizontalPercentageServicios = 0;

  // get footerStyle() {
  //   let result = "";
  //   if (this.$q.screen.xs) {
  //     result = "margin-top: 40px; margin-bottom: 40px;";
  //   } else {
  //     result = "margin-top: 30px; margin-bottom: 30px;";
  //   }
  //   return result;
  // }

  private mounted() {
    this.getBanners();
    this.autoscroll();
    this.getComercios();
    this.getPopUp();
    this.autoscrollBeneficios();
    // this.autoscrollServicios();
  }
  private updated() {
    this.showSlides(this.slideIndex);
  }

  private toLink(link) {
    if (link != "#") {
      window.open(link, "_blank");
    }
  }

  private getPopUp() {
    this.$axios
      .get("popup")
      .then(res => {
        let base = process.env.VUE_APP_BASE_URL;
        this.popUp = res.data;

        for (let i = 0; i < this.popUp.length; i++) {
          if (this.popUp[i].imagen != "") {
            this.popUp[i].imagen = base + this.popUp[i].imagen;
          }
        }

        if (this.popUp.length == 1) {
          this.verPopUp = true;
          this.verPopUpMultiple = false;
        } else {
          this.verPopUp = false;
          this.verPopUpMultiple = true;
        }
      })
      .catch((err: any) => {
        this.popUp = [];
        this.verPopUp = false;
        this.verPopUpMultiple = false;
      });
  }

  private clickPopUp(popUp) {
    if (popUp && popUp.url && popUp.url != "") {
      window.open(popUp.url, "_self");
    }
  }

  private getBanners() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios("slider")
      .then(res => {
        let base = process.env.VUE_APP_BASE_URL;
        this.aBanners = res.data;
        for (let index = 0; index < this.aBanners.length; index++) {
          this.aBanners[index].imagen = base + this.aBanners[index].imagen;
          if (
            this.aBanners[index].imagen_mobile &&
            this.aBanners[index].imagen_mobile != ""
          ) {
            this.aBanners[index].imagen_mobile =
              base + this.aBanners[index].imagen_mobile;
          } else {
            this.aBanners[index].imagen_mobile =
              base + this.aBanners[index].imagen;
          }
          if (!this.aBanners[index].link) {
            this.aBanners[index].link = "#";
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.aBanners = [];
      });
  }
  private autoscroll() {
    this.plusSlides(1);
    setTimeout(this.autoscroll, 5000);
  }

  // seccion comercios logos
  private getComercios() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios("comercios/destacados")
      .then(res => {
        let base = process.env.VUE_APP_BASE_URL;
        this.aComercios = res.data;

        for (let index = 0; index < this.aComercios.length; index++) {
          if (
            this.aComercios[index].logo != null &&
            this.aComercios[index].logo
          ) {
            this.aComercios[index].logo = base + this.aComercios[index].logo;
          } else {
            this.aComercios[
              index
            ].logo = require("@/assets/logos/img-default-actividades.png");
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.aComercios = [];
      });
  }
  private scrollAreaFunctionComercios(info: any) {
    this.horizontalPercentageComercios = info.horizontalPercentage;
  }

  private scroll(direccion: string) {
    if (this.$refs.scrollComercios as any) {
      const size = (this.$refs.scrollComercios as any).scroll.horizontal.size;
      const position = (this.$refs.scrollComercios as any).scroll.horizontal
        .position;
      if (direccion == "derecha") {
        if (this.horizontalPercentageComercios >= 1) {
          (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position + 180,
            120
          );
        }
      } else {
        if (position - 90 < 0) {
          if (position > 0) {
            (this.$refs.scrollComercios as any).setScrollPosition(0, 120);
          } else {
            (this.$refs.scrollComercios as any).setScrollPosition(size, 120);
          }
        } else {
          (this.$refs.scrollComercios as any).setScrollPosition(
            position - 90,
            120
          );
        }
      }
    }
  }
  private autoscrollBeneficios() {
    this.scroll("derecha");
    setTimeout(this.autoscrollBeneficios, 5000);
  }

  // seccion servicios
  private scrollAreaFunctionServicios(info: any) {
    this.horizontalPercentageServicios = info.horizontalPercentage;
  }
  private scrollServicios(direccion: string) {
    if (this.$refs.scrollServicios as any) {
      const size = (this.$refs.scrollServicios as any).scroll.horizontal.size;
      const position = (this.$refs.scrollServicios as any).scroll.horizontal
        .position;

      if (direccion == "derecha") {
        if (this.horizontalPercentageServicios >= 1) {
          (this.$refs.scrollServicios as any).setScrollPosition(0, 400);
        } else {
          (this.$refs.scrollServicios as any).setScrollPosition(
            position + 250,
            500
          );
        }
      } else {
        if (position - 90 < 0) {
          if (position > 0) {
            (this.$refs.scrollServicios as any).setScrollPosition(0, 700);
          } else {
            (this.$refs.scrollServicios as any).setScrollPosition(size, 700);
          }
        } else {
          (this.$refs.scrollServicios as any).setScrollPosition(
            position - 250,
            720
          );
        }
      }
    }
  }
  private autoscrollServicios() {
    this.scrollServicios("derecha");
    setTimeout(this.autoscrollServicios, 10000);
  }

  private irBeneficio(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Beneficio" &&
      this.$router.currentRoute.params.name == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Beneficio",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  private irRequisitos() {
    this.$router.push({ name: "Requisitos" });
  }
  // Funciones del banner
  // Next/previous controls
  private plusSlides(n) {
    this.showSlides((this.slideIndex += n));
  }

  // Thumbnail image controls
  private currentSlide(n) {
    this.showSlides((this.slideIndex = n));
  }

  private showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    if (slides.length > 0) {
      for (i = 0; i < slides.length; i++) {
        (slides[i] as any).style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }

      (slides[this.slideIndex - 1] as any).style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    }
  }

  // Fin Funciones del banner
}
